import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './ResetPasswordPage.css';
import { url } from 'inspector';
axios.defaults.baseURL = process.env.REACT_APP_BRAVERMAN;
const apiUrl = process.env.REACT_APP_BRAVERMAN
const VerifyCode = () => {
  const [email, setEmail] = useState(sessionStorage.getItem('email') || '');
  const [verificationCode, setVerificationCode] = useState('');
  const [message, setMessage] = useState('');
  const [isCodeSent, setIsCodeSent] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    console.log("email: ", email);

    if (!email) {
      setMessage('אין כתובת מייל שמורה, אנא חזור לעמוד ההתחברות והזן אימייל.');
    }
  }, [email]);
  const sendVerificationCode = async () => {
    if (!email) {
      setMessage('לא ניתן לשלוח קוד ללא כתובת מייל!');
      return;
    }
    setMessage('');
    try {
      console.log("בדיקה");
      await axios.post(`${apiUrl}User/SendVerificationCode`, { email });
      setIsCodeSent(true);
      setMessage('קוד אימות נשלח למייל שלך!');
    } catch (error: any) {
      if (error.response) {
        if (error.response.status === 400) {
          setMessage('כתובת המייל אינה תקינה');
        } else if (error.response.status === 404) {
          console.log("error.response: ", error.response);

          setMessage('משתמש לא קיים במערכת');
        } else {
          setMessage('שגיאה בלתי צפויה. נסה שוב מאוחר יותר.');
        }
      } else {
        setMessage('שגיאת חיבור לשרת. בדוק את האינטרנט ונסה שוב.');
      }
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setMessage('');
    console.log("שליחת בקשה ל-VerifyCode:", { email, verificationCode });
    try {
      // console.log("מייל");
      // console.log(email);
      // console.log(verificationCode)
      const response = await axios.post(`${apiUrl}User/VerifyCode`, {
         email,
        verificationCode
      });
      console.log("תגובה מהשרת:", response.data); // לוג לבדיקת תגובה
      // alert(response.data); // "קוד אימות נשלח בהצלחה!"
      if (response.data.success) {
        navigate('/forgot-password', { replace: true }); navigate('/Forgot-password', { replace: true });
      } else {
        setMessage('קוד אימות שגוי. נסה שוב.');
      }
    } catch (error: any) {
      console.error("שגיאת שרת:", error); // לוג במקרה של שגיאה
      setMessage('שגיאת שרת. אנא נסה שוב מאוחר יותר.');
    }
  };

  return (
    <div className="verify-container">
      <div className="verify-card">
        <h2 className="verify-title">שחזור סיסמה</h2>
        {!isCodeSent ? (
          <button className="send-code-button" onClick={sendVerificationCode}>
            שלח לי קוד אימות
          </button>
        ) : (
          <>
            <h3 className="verify-subtitle">קוד אימות נשלח למייל שלך</h3>
            <form className="verify-form" onSubmit={handleSubmit}>
              <label className="verify-label">הכנס קוד אימות:</label>
              <input
                className="verify-input"
                type="text"
                value={verificationCode}
                onChange={(e) => setVerificationCode(e.target.value)}
                required
              />
              <button className="verify-button" type="submit">שלח</button>
            </form>
          </>
        )}
        {message && <p className="verify-message">{message}</p>}
      </div>
    </div>
  );
};
export default VerifyCode;

